/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./authorize-plan-authority.vue?vue&type=template&id=3dc3d91b&scoped=true&"
import script from "./authorize-plan-authority.vue?vue&type=script&lang=js&"
export * from "./authorize-plan-authority.vue?vue&type=script&lang=js&"
import style0 from "./authorize-plan-authority.vue?vue&type=style&index=0&id=3dc3d91b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc3d91b",
  null
  
)

export default component.exports